export const FontGap = 3; //多行文本行间距

function prepareCanvas(width, height, ratio = 1){
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const realWidth = width * ratio;
  const realHeight = height * ratio;
  canvas.setAttribute('width', `${realWidth}px`);
  canvas.setAttribute('height', `${realHeight}px`);
  ctx.save();
  return [ctx, canvas, realWidth, realHeight];
}

// 生成水印
export default function useClips() {
  return function (options={}){
    // console.log('canvas 参数', {...options});
    const {
      content, //水印内容
      rotate, //旋转角度, 单位 °
      ratio,  //设备像素比
      width,  //内容宽高
      height,
      font, //字体样式
      gapX, //间距
      gapY
    } = options;
    const [ctx, canvas, contentWidth, contentHeight] = prepareCanvas(width, height, ratio);

    if (content instanceof HTMLImageElement) {
      // 图片
      ctx.drawImage(content, 0, 0, contentWidth, contentHeight);
    } else {
      // 文本
      const {color, fontSize, fontStyle, fontWeight, fontFamily, textAlign, textBaseline} = font;
      const mergedFontSize = Number(fontSize) * ratio;
      ctx.font = `${fontStyle} normal ${fontWeight} ${mergedFontSize}px/${height}px ${fontFamily}`;      
      ctx.fillStyle = color;
      ctx.textAlign = textAlign;
      ctx.textBaseline = textBaseline;

      const contents = Array.isArray(content) ? content : [content];
      contents?.forEach((item, index) => {
        ctx.fillText(
          item ?? '',
          contentWidth / 2,
          index * (mergedFontSize + FontGap * ratio)
        )
      })
      // ctx.strokeRect(0, 0, contentWidth, contentHeight);
    }

    // 处理旋转
    const angle = (Math.PI / 180) * Number(rotate);
    const maxSize = Math.max(width, height);
    const [rCtx, rCanvas, realMaxSize] = prepareCanvas(maxSize, maxSize, ratio);

    rCtx.translate(realMaxSize / 2, realMaxSize / 2);
    rCtx.rotate(angle);
    if (contentWidth > 0 && contentHeight > 0) {
      rCtx.drawImage(canvas, -contentWidth / 2, -contentHeight / 2);
    }

    // 获取旋转文本的边界
    function getRotatePos(x, y) {
      const targetX = x * Math.cos(angle) - y * Math.sin(angle);
      const targetY = x * Math.sin(angle) + y * Math.cos(angle);
      return [targetX, targetY];
    }

    let left = 0;
    let right = 0;
    let top = 0;
    let bottom = 0;

    const halfWidth = contentWidth / 2;
    const halfHeight = contentHeight / 2;
    const points = [
      [0 - halfWidth, 0 - halfHeight],
      [0 + halfWidth, 0 - halfHeight],
      [0 + halfWidth, 0 + halfHeight],
      [0 - halfWidth, 0 + halfHeight],
    ];
    points.forEach(([x, y]) => {
      const [targetX, targetY] = getRotatePos(x, y);
      left = Math.min(left, targetX);
      right = Math.max(right, targetX);
      top = Math.min(top, targetY);
      bottom = Math.max(bottom, targetY);
    });

    const cutLeft = left + realMaxSize / 2;
    const cutTop = top + realMaxSize / 2;
    const cutWidth = right - left;
    const cutHeight = bottom - top;

    // 交替填充到画板上
    const realGapX = gapX * ratio;
    const realGapY = gapY * ratio;
    const filledWidth = (cutWidth + realGapX) * 2;
    const filledHeight = cutHeight + realGapY;

    const [fCtx, fCanvas] = prepareCanvas(filledWidth, filledHeight);
    // fCtx.strokeRect(0, 0, filledWidth, filledHeight);

    function drawImg(targetX = 0, targetY = 0) {
      fCtx.drawImage(
        rCanvas, 
        cutLeft, cutTop, cutWidth, cutHeight,
        targetX, targetY, cutWidth, cutHeight
      );
    }
    drawImg();
    drawImg(cutWidth + realGapX, -cutHeight / 2 - realGapY / 2);
    drawImg(cutWidth + realGapX, +cutHeight / 2 + realGapY / 2);

    return [fCanvas.toDataURL(), filledWidth / ratio, filledHeight / ratio];
  }
}